module.exports = __webpack_public_path__ + "img/logo-h.png?901a93f0207dde9503598b24e1dc0c7e";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/src/assets/img/logo-h.png
// module id = 65
// module chunks = 0